@if (!loadingRecords) {
  <div style="width: 100%;" class="receipt-container" [ngClass]="{'receipt-no-records': !hasAnyPaid}">
    @if (hasAnyPaid) {
      <div>
        @if (isPaid) {
          <div class="grid-x">
            <div class="cell small-12 medium-6">
              <h2 class="receipt-header-confirmation">Payment Confirmation</h2>
            </div>
            <div class="cell small-12 medium-6 text-align-right">
              @if (autoGeneratePdf && showButtons) {
                <button class="button" [disabled]="disableReceipt" (click)="download()">Download PDF Receipt</button>
              }
              @if (!autoGeneratePdf && showButtons) {
                <button class="button" [disabled]="hasPartials" (click)="issueReceipt()">Issue Receipt</button>
              }
            </div>
          </div>
          <div [id]="getDocumentId('Receipt')" style="width: 100%;"  [ngClass]="{ 'shrink-font': shrinkFont }">
            <table style="table-layout: fixed; width: 100%; border-collapse: separate; border-spacing: 0px 5px; margin-top: 48px;">
              <caption>Receipt for Application # {{applicationNumber}}</caption>
              <thead style="background-color: transparent;">
                <tr>
                  <td style="width: 65%;"></td>
                  <td style="width: 35%;"></td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colspan="2" style="background-color: #dddddd; font-weight: bold; padding: 10px 0px 10px 1rem; font-size: 14px; line-height: 14px; text-align: left;">
                    Receipt for Application # {{applicationNumber}}
                  </td>
                </tr>
                @if (isCredit) {
                  <tr style="background-color: transparent;">
                    <td colspan="2" style="padding: 0 1rem; font-weight: bold;">Order Number: {{orderNumber}}</td>
                  </tr>
                  <tr style="background-color: transparent;">
                    <td colspan="2" style="padding: 0 1rem; font-weight: bold;">Date: {{dateAuthorized | date: 'MM/dd/yyyy hh:mm:ss a'}}</td>
                  </tr>
                }
                @if (records && records.length > 0) {
                  <tr >
                    <td colspan="2" style="background-color: #dddddd; line-height: 14px; font-size: 14px; font-weight: bold; padding: 10px 0px 10px 1rem; text-align: left;">
                      Owner: {{records[0].organizationId}} - {{records[0].organization}}
                    </td>
                  </tr>
                }
                <tr style="background-color: transparent;">
                  <td colspan="2" style="padding-left: 1rem;">
                    <div style="font-weight: bold; float: left; padding-right: 10px;">Payment Type@if (paymentTypes.length > 1) {
                      s
                    }:</div>
                    <div style="float: left;">
                      @for (pmt of getDisplayTokens(paymentTypes); track pmt) {
                        @if (pmt.instrumentType === 'Cash') {
                          Cash in the amount of {{ pmt.instrumentAmount | currency: 'USD':'symbol':'1.2-2' }} <br />
                        }
                        @if (pmt.instrumentType === 'Check') {
                          Check {{pmt.instrumentToken}} in the amount of {{ pmt.instrumentAmount | currency: 'USD':'symbol':'1.2-2' }} @if (pmt.appliedAmount !== 0) {
                          <span>- {{ pmt.appliedAmount | currency: 'USD':'symbol':'1.2-2'}} applied</span>
                          } <br />
                        }
                        @if (pmt.instrumentType === 'Money Order') {
                          Money Order {{pmt.instrumentToken}} in the amount of {{ pmt.instrumentAmount | currency: 'USD':'symbol':'1.2-2' }} @if (pmt.appliedAmount !== 0) {
                          <span>- {{ pmt.appliedAmount | currency: 'USD':'symbol':'1.2-2'}} applied</span>
                          } <br />
                        }
                        @if (pmt.instrumentType === 'Credit') {
                          Credit Authorization {{pmt.instrumentToken}} in the amount of {{ pmt.instrumentAmount | currency: 'USD':'symbol':'1.2-2'}} @if (pmt.appliedAmount !== 0) {
                          <span>- {{pmt.appliedAmount | currency: 'USD':'symbol':'1.2-2'}} applied</span>
                          } <br />
                        }
                      }
                    </div>
                  </td>
                </tr>
                @if (isCredit) {
                  <tr style="background-color: transparent;">
                    <td colspan="2" style="padding-left: 1rem;">
                      <div style="font-weight: bold; float: left; padding-right: 10px;">
                        Billing Address:
                      </div>
                      <div style="float: left;">
                        {{companyName}}<br />
                        {{address1}}<br />
                        {{city}}, {{state}} {{zipCode}}<br />
                        Phone Number: {{phoneNumber}}<br />
                        @if (emailAddress.length > 0) {
                          Email: {{emailAddress}}
                        }
                      </div>
                    </td>
                  </tr>
                }
                @if (!isCredit) {
                  <tr style="background-color: transparent;">
                    <td colspan="2" style="padding-left: 1rem;">
                      {{companyName}}
                    </td>
                  </tr>
                }
                <tr style="background-color: transparent;">
                  <td colspan="2" style="text-align: left; font-weight: bold; padding: 0 1rem;">
                    Description:
                  </td>
                </tr>
                @for (payment of records; track payment) {
                  <tr style="background-color: transparent;">
                    <td style="padding-left: 1rem; white-space: nowrap; overflow: hidden; vertical-align: bottom;" [ngClass]="{ 'shrink-font': shrinkFont }">
                      {{payment.description}}@if (payment.instrumentType !== 'Credit') {
                      (reference # {{payment.id}})
                      }{{filler}}
                    </td>
                    <td style="padding-right: .5rem; white-space: nowrap; text-align: right; direction: rtl; overflow: hidden; vertical-align: bottom;" [ngClass]="{ 'shrink-font': shrinkFont }">
                      <span style="font-weight: bold;">
                        Fee:
                      </span>
                      {{ payment.fee | currency: 'USD': symbol: '1.2-2'}} - <span style="font-weight: bold;">Paid:</span> <span [ngStyle]="{ 'font-style': (payment.paymentStatus === 'Partial') ? 'italic' : 'normal'}"> {{payment.amountPaid | currency: 'USD': 'symbol': '1.2-2'}}</span>{{filler}}
                    </td>
                  </tr>
                }
              </tbody>
              <tfoot style="background-color: transparent; border-collapse: collapse;">
                <tr>
                  <td colspan="2" style="padding: 5px 0 5px 0; text-align: right; font-weight: bold; border-top: solid 1px black;">Total Due: {{ totalDue }}</td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 5px 0 5px 0; text-align: right; font-weight: bold; ">Total Paid: {{totalPaid}}</td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 5px 0 5px 0; text-align: right; font-weight: bold; border-top: solid 1px black;" [ngStyle]="{ 'font-style': (totalPaid !== totalDue) ? 'italic': 'normal' }">Remaining Due: {{remainingDue}}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        }
        @if (!isPaid) {
          <div style="width: 100%; display: flex; flex-direction: row;">
            <div style="flex-grow: 1; text-align: left;">
              <h2>Amount Invoiced</h2>
            </div>
            <div style="flex-grow: 1; text-align: right;">
              @if (showButtons) {
                <button class="button" [disabled]="disableDownloadInvoice" (click)="download()">Download Invoice</button>
              }
            </div>
          </div>
          <div [id]="getDocumentId('Invoice')">
            <table style="table-layout: fixed; width: 100%; border-collapse: separate; border-spacing: 0px 5px; margin-top: 48px;">
              <caption>Invoice for Application #: {{applicationNumber}}</caption>
              <thead style="background-color: transparent;">
                <tr>
                  <td style="width: 80%;"></td>
                  <td style="width: 20%;"></td>
                </tr>
              </thead>
              <tbody>
                <tr style="background-color: #dddddd; font-size: 14px; font-weight: bold; padding: 2px 0px 2px 1rem; text-align: left;">
                  <td colspan="2">
                    Invoice for Application #: {{applicationNumber}}
                  </td>
                </tr>
                @if (records && records.length > 0) {
                  <tr style="background-color: #dddddd; font-size: 14px; font-weight: bold; padding: 2px 0px 2px 1rem; text-align: left;">
                    <td colspan="2">
                      Owner: {{records[0].organizationId}} - {{records[0].organization}}
                    </td>
                  </tr>
                }
                @for (payment of records; track payment) {
                  <tr style="padding: 5px 0px 5px 1rem; background-color: transparent;">
                    <td style="white-space: nowrap; overflow: hidden;">{{payment.description}} (reference #{{payment.id}}){{filler}}</td>
                    <td style="padding-right: 0px; white-space: nowrap; text-align: right; direction: rtl; overflow: hidden;">{{payment.fee | currency: 'USD':'symbol':'1.2-2'}}{{filler}}</td>
                  </tr>
                }
              </tbody>
              <tfoot style="background-color: transparent;">
                <tr>
                  <td colspan="2" style="padding: 10px 0 5px 0; text-align: right; font-weight: bold; border-top: solid 1px black;">Total: {{ totalDue }}</td>
                </tr>
                <tr>
                  <td colspan="2" style="font-size: .7rem; width: 100%; text-align: right;">
                    **Please include the application number and applicable reference number(s) for the above payments when remitting payment(s).**
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        }
      </div>
    } @else {
      <div style="width: 100%; font-size: .85rem;">
        No payments have been made to issue a receipt for Application #{{applicationNumber}}.
      </div>
    }
  </div>
} @else {
  <div style="width: 100%;">
    Loading payments ... please wait ...
  </div>
}
<a href="" style="display:none" target="_blank"  #downloadLink></a>